import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgSuccess = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    ref={svgRef}
    {...props}
  >
    <path
      fill="#084"
      fillRule="evenodd"
      d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm3.932-10.638a.776.776 0 00-1.048.09L7.334 9.46 5.47 7.704l-.083-.067a.779.779 0 00-.969.068.672.672 0 000 .99l2.442 2.3.081.066c.311.22.76.177 1.017-.113l4.07-4.599.059-.077a.673.673 0 00-.155-.91z"
      clipRule="evenodd"
    />
  </svg>
));
SvgSuccess.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgSuccess;
